import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Icon } from "@chakra-ui/react";
import { FaStar, FaRegStar } from "react-icons/fa";
const InteractiveStarRating = ({ value, onChange, size = 6, filledColor = "#E3BD36", emptyColor = "white", emptyStrokeColor, emptyStrokeWidth, }) => {
    const totalStars = 5;
    return (_jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", gap: 1, children: Array.from({ length: totalStars }, (_, i) => {
            const starValue = i + 1;
            const isFilled = value >= starValue;
            return (_jsx(Box, { as: "button", type: "button", onClick: () => onChange(value === starValue ? 0 : starValue), onKeyDown: (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onChange(value === starValue ? 0 : starValue);
                    }
                }, tabIndex: 0, "aria-label": `Rate ${starValue} out of ${totalStars} stars`, _hover: { opacity: 0.9 }, _focus: { outline: "none" }, cursor: "pointer", bg: "transparent", border: "none", p: 0, children: _jsx(Icon, { as: isFilled ? FaStar : FaRegStar, boxSize: size, color: isFilled ? filledColor : emptyColor, sx: !isFilled && emptyStrokeColor && emptyStrokeWidth
                        ? {
                            stroke: emptyStrokeColor,
                            strokeWidth: emptyStrokeWidth,
                        }
                        : undefined, transition: "color 0.2s" }) }, starValue));
        }) }));
};
export default InteractiveStarRating;
